import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from './http-client';

@Injectable()
export class CommonService {

    constructor(private httpClient: HttpClient) {}

    getMonthLabelsMapping() {
        return {
            'enero': 'ENE', 'febrero': 'FEB', 'marzo': 'MAR', 'abril': 'ABR', 'mayo': 'MAY', 'junio': 'JUN',
            'julio': 'JUL', 'agosto': 'AGO', 'septiembre': 'SEP', 'octubre': 'OCT', 'noviembre': 'NOV', 'diciembre': 'DIC'
        };
    }

    getCurrentPosicionShortName() {
        let monthLabels = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
        let today = moment();
        let currentMonth = today.month();
        let currentYear = today.year();
        let currentYearStr = currentYear.toString().slice(2);
    
        let result = monthLabels[currentMonth] + '-' + currentYearStr;
        return result;
    }

    getPosicionShortName(fullName) {
      const mapping = this.getMonthLabelsMapping();
      const parts = fullName.split('-');
      return mapping[parts[0]] + '-' + parts[1];
    }

    /**
     * Get the first business day for the month of a given moment object, 
     * or current month if none provided 
     * @param input MomentJS datetime object input
     * @returns First business day as a MomentJS object
     */
    getFirstBusinessDay(input?: moment.Moment) {
        let temp: moment.Moment;

        // Determinar fecha base
        if (typeof input !== 'undefined') {
            temp = input.clone();
        } else {
            temp = moment().startOf('month');
        }

        // Extraer año y mes
        const year = temp.year();
        const month = temp.month() + 1 // Recordar que .month() retorna los meses en rango 0-11

        const url = '/api/negocio/primer-dia-habil';
        let params = `?month=${month}&year=${year}`;

        return this.httpClient.get(url + params).map(response => {
            if (response) {
                return moment.unix(response.json().ResponseData).add(3, 'hours'); // Se retorna el resultado convertido a un objeto de MomentJS
            }
        })
    }
}


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/common-service.ts